// Module
var code = "<ktable query=\"component.query\" component=\"component\" options=\"ktableOptions\" ng-disabled=\"readOnly || component.disabled\" ng-model=\"$ctrl.tmp[componentId]\" ktable-validate=\"component.validate\" widget-actions=\"widgetActions\" ng-attr-name=\"{{ componentId || component.key }}\"></ktable> ";
// Exports
export default code;